import loader from '../../common/loader'; // import cookie from '../../common/cookie';
// import miloRequest from '../../common/network';

import platform from '../../common/platform'; // 掌盟多渠道接入 add by weiztang

var jsApi = 'https://mlol-file.qpic.cn/mobile/mlol/js/wgwebbridge.js'; // const qqAppid = '';
// const wxAppid = '';

var loginFuncsTips = 'please use LoginManager, not jsBridge';
var miloSelfConfig = {
  isMiloWayCookies: true,
  appName: 'lolapp'
}; // 加载jsBridge，活动开发可以自行指定版本号

var loadJsApi = function loadJsApi(jsApiCustom) {
  return new Promise(function (resolve, reject) {
    var loadJsApiUrl = jsApiCustom || jsApi;

    if (window.mlolweb) {
      resolve(window.mlolweb);
      return;
    }

    loader.loadScript(loadJsApiUrl).then(function (isLoad) {
      if (isLoad && window.mlolweb) {
        resolve(window.mlolweb);
      } else {
        reject();
      }
    })["catch"](function (e) {
      reject(e);
    });
  });
};

var loginByQQAndWX = function loginByQQAndWX() {
  console.log(loginFuncsTips);
};

var loginByWX = function loginByWX() {
  console.log(loginFuncsTips);
};

var loginByQQ = function loginByQQ() {
  console.log(loginFuncsTips);
};

var setAppCookie = function setAppCookie() {
  return new Promise(function (resolve) {
    console.log(loginFuncsTips);
    resolve();
  });
};

var getLoginType = function getLoginType() {
  return new Promise(function (resolve) {
    resolve(null);
  });
};

var logout = function logout() {
  if (platform.ios()) {
    console.log('lolapp in ios exec logout api start');
    loadJsApi().then(function (JsBridge) {
      var isDelJsBridgeAvailable = false;
      var lolVersion = navigator.userAgent.toLowerCase().match(/lolapp\/(\d+\.)+\d+/);
      lolVersion = lolVersion && lolVersion.length && lolVersion[0];

      if (lolVersion && lolVersion.split('/').length > 1) {
        lolVersion = lolVersion.split('/')[1];
        var versionArr = lolVersion.split('.');

        if (versionArr.length > 1) {
          isDelJsBridgeAvailable = versionArr[0] >= 8 && versionArr[1] >= 1;
        }
      }

      if (JsBridge && JsBridge.deleteCookies && isDelJsBridgeAvailable) {
        JsBridge.deleteCookies({
          success: function success(data) {
            console.log(JSON.stringify(data));
          },
          fail: function fail(data) {
            console.log("err".concat(JSON.stringify(data)));
          }
        });
      }
    })["catch"](function () {});
  }
};

var lolapp = {
  // 不开放方法，请使用LoginManager
  loginByWX: loginByWX,
  loginByQQ: loginByQQ,
  loginByQQAndWX: loginByQQAndWX,
  setAppCookie: setAppCookie,
  getLoginType: getLoginType,
  logout: logout,
  loadJsApi: loadJsApi,
  miloSelfConfig: miloSelfConfig
};
export default lolapp;